import { Row, Col } from 'react-bootstrap'
import { useObfuscatedContact } from './useObfuscatedContact'

const PrivacyPolicy = () => {
    const { email1, address } = useObfuscatedContact()
    return (
        <Row className="legalPage mx-0" id="privacy">
            <Row className="legalContent mx-0 justify-content-center">
                <Col className="col-12 col-lg-8">
                    <h1 className="legalTitle">Privacy Policy</h1>
                    <p className="legalDate">Last updated: January 2026</p>
                    
                    <div className="legalSection">
                        <h2>1. Introduction</h2>
                        <p>
                            Linko Labs LLC ("we," "our," or "us") is committed to protecting your privacy. 
                            This Privacy Policy explains how we collect, use, and safeguard your information 
                            when you visit our website or engage our services.
                        </p>
                    </div>

                    <div className="legalSection">
                        <h2>2. Information We Collect</h2>
                        <p>We may collect the following types of information:</p>
                        <ul>
                            <li><strong>Contact Information:</strong> Name, email address, phone number when you contact us or request a consultation.</li>
                            <li><strong>Business Information:</strong> Company name, project requirements, and related business details.</li>
                            <li><strong>Technical Data:</strong> IP address, browser type, and usage data collected through cookies and analytics.</li>
                        </ul>
                    </div>

                    <div className="legalSection">
                        <h2>3. How We Use Your Information</h2>
                        <p>We use your information to:</p>
                        <ul>
                            <li>Respond to inquiries and provide consultations</li>
                            <li>Deliver contracted services</li>
                            <li>Improve our website and services</li>
                            <li>Communicate about project updates and business matters</li>
                            <li>Comply with legal obligations</li>
                        </ul>
                    </div>

                    <div className="legalSection">
                        <h2>4. Information Sharing</h2>
                        <p>
                            We do not sell your personal information. We may share information with:
                        </p>
                        <ul>
                            <li>Service providers who assist in delivering our services</li>
                            <li>Legal authorities when required by law</li>
                            <li>Professional advisors for business operations</li>
                        </ul>
                    </div>

                    <div className="legalSection">
                        <h2>5. Data Security</h2>
                        <p>
                            We implement appropriate technical and organizational measures to protect 
                            your information against unauthorized access, alteration, or destruction.
                        </p>
                    </div>

                    <div className="legalSection">
                        <h2>6. Your Rights</h2>
                        <p>
                            You have the right to access, correct, or delete your personal information. 
                            To exercise these rights, please contact us at {email1}.
                        </p>
                    </div>

                    <div className="legalSection">
                        <h2>7. Cookies</h2>
                        <p>
                            Our website uses cookies to improve functionality and analyze usage. 
                            You can control cookie preferences through your browser settings.
                        </p>
                    </div>

                    <div className="legalSection">
                        <h2>8. Contact Us</h2>
                        <p>
                            For questions about this Privacy Policy, please contact us at:
                        </p>
                        <p>
                            {address?.company}<br />
                            {address?.street}<br />
                            {address?.city}<br />
                            Email: {email1}
                        </p>
                    </div>
                </Col>
            </Row>
        </Row>
    )
}

export default PrivacyPolicy
